import nyt from './data/nytBestTvShows.json';
import emmys from './data/emmyTvNominations';

export const EMMY_CATEGORY_ORDER = ['drama', 'comedy', 'limited', 'reality', 'animated', 'variety'];
export const EMMY_NOMINEE_IDS = [...new Set(EMMY_CATEGORY_ORDER.flatMap(category =>
  (emmys['2026'][category] || []).map(entry => entry.id)))];
export const EMMY_WINNER_ORDER = EMMY_CATEGORY_ORDER.flatMap(category =>
  (emmys['2026'][category] || []).filter(entry => entry.won).map(entry => entry.id));
export const TV_CURATOR_PICK_IDS = [...new Set([
  ...nyt.entries.map(entry => entry.tmdbId), ...EMMY_NOMINEE_IDS,
])];

/** Winners lead in category order; all other nominees retain their score order. */
export function orderAwardNominatedItems(items) {
  const winnerRanks = new Map(EMMY_WINNER_ORDER.map((id, index) => [id, index]));
  return [...items].sort((a,b) =>
    (winnerRanks.get(Number(a.tmdbId ?? a.id)) ?? 999)
    - (winnerRanks.get(Number(b.tmdbId ?? b.id)) ?? 999))
    .map((item,index) => ({...item,rank:index+1}));
}

/** Shuffle the complete curated pool without repeats or score/age exclusions. */
export function shuffleCuratorPicks(items, random = Math.random) {
  const allowed = new Set(TV_CURATOR_PICK_IDS);
  const seen = new Set();
  const pool = items.filter(item => {
    const id = Number(item.tmdbId ?? item.id);
    if (!allowed.has(id) || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
  for(let i=pool.length-1;i>0;i--){
    const j=Math.floor(random()*(i+1));
    [pool[i],pool[j]]=[pool[j],pool[i]];
  }
  return pool;
}
